/**
 * Захват и хранение реферера из ссылки `?ref=<id>` до момента регистрации.
 *
 * Клик по реферальной ссылке (https://realcolibri.com/?ref=6) сам по себе
 * ничего не привязывает: аккаунт создаётся позже, при подписи TronLink.
 * Поэтому id реферера мы запоминаем в localStorage сразу при заходе, а при
 * регистрации отдаём его в `tronVerify` → бэкенд авто-привязывает referrer_id.
 * После успешной привязки метку чистим.
 */
const REF_KEY = 'rc_ref'

/** Ловит `?ref=<id>` из текущего URL и запоминает (если ещё не сохранён). */
export const captureReferralRef = (): void => {
    try {
        const raw = new URLSearchParams(window.location.search).get('ref')
        if (!raw) return
        const id = Number(raw)
        if (Number.isInteger(id) && id > 0) {
            localStorage.setItem(REF_KEY, String(id))
        }
    } catch {
        /* no-op */
    }
}

/** Сохранённый id реферера (или undefined). */
export const getReferralRef = (): number | undefined => {
    try {
        const raw = localStorage.getItem(REF_KEY)
        if (!raw) return undefined
        const id = Number(raw)
        return Number.isInteger(id) && id > 0 ? id : undefined
    } catch {
        return undefined
    }
}

/** Чистит сохранённый ref (после успешной регистрации/привязки). */
export const clearReferralRef = (): void => {
    try {
        localStorage.removeItem(REF_KEY)
    } catch {
        /* no-op */
    }
}
